<template>
  <v-app id="inspire" style="background:#fcf9f4;">
    <router-view></router-view>
  </v-app>
</template>

<script>
/* import Carousel from "@/components/Carousel";
 */
//import LangSwitch from "@/components/LangSwitch";

export default {
  data: () => ({
    group: null,
    showMenu: false
    //    links: ["Home", "Paket Tour", "About", "Contact"],
  }),
  components: {}
};
</script>
<style lang="sass" scoped>
.fade-enter-active,
.fade-leave-active
    transition: opacity .5s

.fade-enter,
.fade-leave-to
    opacity: 0
</style>
